<template>
  <div class="deatil-container">
    <CuHeader title="预问诊-让医生更早了解您的病情"></CuHeader>
    <div class="deatil-content">
      <ul>
        <li v-for="(item, index) in list" :key="item.id" class="item">
          <!-- <template v-if="item['答案']"> -->
          <span class="left">{{ index + 1 + "." + item.question }}</span>
          <span class="right">{{ item.answer }}</span>
          <!-- </template> -->
        </li>
      </ul>
    </div>
    <div style="text-align: center" class="title">
      同意将电子问卷内容发送给您的预约医生
    </div>
    <footer class="footer">
      <van-button
        type="danger"
        round
        class="footer-item"
        size="small"
        @click="bandleBack"
        v-if="path !== 'history'"
        >返回修改</van-button
      >
      <van-button
        type="primary"
        round
        class="footer-item"
        size="small"
        @click="handleHistory"
        v-if="path !== 'history'"
        >确认发送</van-button
      >
      <van-button
        type="danger"
        round
        class="footer-item"
        size="small"
        v-if="path == 'history'"
        @click="handleBackHistory"
        >返回历史</van-button
      >
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import CuHeader from "../../components/CuHeader.vue";
import { getAnswer, saveOk } from "@/api/detail.js";
let detailTimer = null;
Vue.use(Toast);
export default {
  name: "Deatil",
  components: {
    CuHeader,
  },
  data() {
    return {
      list: [],
      path: "",
      catchData: {},
      patientId: undefined,
    };
  },
  mounted() {
    const { path } = this.$route.query;
    if (path) {
      this.path = path;
    }
    this.getData();
  },
  computed: {
    height() {
      const pElement = document.querySelector("html"); // 选择第一个<p>元素
      const style = window.getComputedStyle(pElement); // 获取计算后的样式
      const fontSize = parseInt(style.fontSize); //
      const total = (window.innerHeight / fontSize).toFixed(6);
      return total - 5.8 + "rem";
    },
  },
  beforeDestroy() {
    detailTimer && clearTimeout(detailTimer);
  },
  methods: {
    bandleBack() {
      this.$router.push({
        path: "/index",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    replaceDecimalNumbersWithMultiplication(input) {
      return input.replace(/\d+\.\d+/g, (match) => {
        // 将匹配到的小数转换为数字类型并乘以 100
        const number = parseFloat(match);
        return number * 100;
      });
    },
    async getData() {
      const { id } = this.$route.query;
      const result = await getAnswer(id);
      if (result.code == 200) {
        try {
          const { modelDialogue } = JSON.parse(result.data.answer);
          this.list = modelDialogue.map((item) => {
            if (item.key == "JWS_JZJBS" && item.answer) {
              const ontjerValue = sessionStorage.getItem("valueOtherValue");
              if (ontjerValue) {
                item.answer = ontjerValue;
              }
            }
            return { ...item };
          });
          this.catchData = result.data;
          this.patientId = result.data.patientId;
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 去到历史记录
    async handleHistory() {
      const result = await saveOk({
        ...this.catchData,
        answerId: this.catchData.id,
      });
      if (result.code == 200) {
        Toast.success("保存成功");
        if (detailTimer) {
          clearTimeout(detailTimer);
        }
        detailTimer = setTimeout(() => {
          this.$router.push({
            path: "/history",
            query: {
              patientId: this.patientId,
            },
          });
        }, 3000);
      } else {
        Toast.fail(result.msg);
      }
    },
    handleBackHistory() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.deatil-container {
  overflow: hidden;
  .deatil-content {
    border: 1px solid #e8e8e8;
    padding: 4px;
    height: calc(100vh - 208px);
    overflow-y: auto;
    padding: 0 15px;
  }
  .item {
    font-size: 14px;
    display: flex;
    line-height: 24px;
    border-bottom: 1px solid #ddd;
    .left {
      display: flex;
      align-items: center;
      width: 65%;
      border-right: 1px dashed #ddd;
    }
    .right {
      width: 35%;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
  .title {
    font-size: 16px;
    padding: 10px 0;
  }
  .footer {
    display: flex;
    justify-content: space-around;
    align-items: end;
    height: 38px;
    .footer-item {
      // flex: 1;
      width: 40%;
      text-align: center;
    }
  }
}
</style>
